// What a sick call did, in plain words — from the `schedule` the server sends back
// (sickCallToSchedule in server/api.js): moved to You Are Off, who on the job was told.
export function sickCallSummary(schedule) {
  const s = schedule || {};
  const told = (s.told || []).length ? ` ${s.told.join(', ')} ${s.told.length === 1 ? 'was' : 'were'} told they're out.` : '';
  let what;
  if (s.note === 'past') what = 'That day has already gone by, so the schedule was left alone.';
  else if (s.note === 'not_linked') what = 'They aren’t linked to QuickBooks Time, so the schedule was left alone.';
  else if (s.note === 'not_scheduled') what = 'They weren’t on the schedule, so nothing moved and no job was told.';
  else if (s.move_error) what = `The schedule did NOT change all the way (${s.move_error}) — move them to You Are Off on QuickBooks Time.${told}`;
  else if (s.moved) what = `Moved to You Are Off on the schedule.${told}`;
  else what = 'Logged.';
  return `${what} The Executives and the office have it.`;
}
